<div class="home">
  <header class="home-welcome">
    <h2>{{_(KEYS.HOME.MYMEDAX_ADMIN)}}</h2>
    <p *ngIf="userName">{{_(KEYS.HOME.WELCOME_USERNAME, {userName: userName})}}</p>
  </header>

  <section class="home-section" *ngIf="canOpen('/module/questionnaire/submission/grid') || canOpen('/module/questionnaire/editor') || canOpen('/module/patient/crud/new') || canOpen('/module/survey/grid')">
    <h3 class="section-title">{{_(KEYS.HOME.QUICK_ACCESS)}}</h3>
    <div class="action-grid">
      <a class="home-card action-card" routerLink="/module/questionnaire/submission/grid"
         *ngIf="canOpen('/module/questionnaire/submission/grid')">
        <span class="card-icon"><i class="fa fa-check" aria-hidden="true"></i></span>
        <h4>{{_(KEYS.HOME.FILLED_QUESTIONNAIRES)}}</h4>
        <p>{{_(KEYS.HOME.SUBMISSIONS_HINT)}}</p>
        <span class="card-link">{{_(KEYS.HOME.OPEN)}} <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
      </a>
      <a class="home-card action-card" routerLink="/module/questionnaire/editor"
         *ngIf="canOpen('/module/questionnaire/editor')">
        <span class="card-icon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
        <h4>{{_(KEYS.HOME.QUESTIONNAIRE_EDITOR)}}</h4>
        <p>{{_(KEYS.HOME.EDITOR_HINT)}}</p>
        <span class="card-link">{{_(KEYS.HOME.OPEN)}} <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
      </a>
      <article class="home-card action-card" *ngIf="canOpen('/module/patient/crud/new')">
        <span class="card-icon"><i class="fa fa-user-plus" aria-hidden="true"></i></span>
        <h4>{{_(KEYS.HOME.NEW_PATIENT)}}</h4>
        <p>{{_(KEYS.HOME.NEW_PATIENT_TEXT)}}</p>
        <div class="card-actions patient-actions">
          <a routerLink="/module/patient/crud/new" *ngIf="!disablePatientNewLink">
            <i class="fa fa-star" aria-hidden="true"></i> {{_(KEYS.HOME.NORMAL)}}
          </a>
          <a routerLink="/module/patient/crud/new/anonymous">
            <i class="fa fa-user-secret" aria-hidden="true"></i> {{_(KEYS.HOME.ANONYMOUS)}}
          </a>
          <a routerLink="/module/patient/crud/new/pseudonymous">
            <i class="fa fa-user-o" aria-hidden="true"></i> {{_(KEYS.HOME.PSEUDONYMOUS)}}
          </a>
        </div>
      </article>
      <a class="home-card action-card" routerLink="/module/survey/grid" *ngIf="canOpen('/module/survey/grid')">
        <span class="card-icon"><i class="fa fa-table" aria-hidden="true"></i></span>
        <h4>{{_(KEYS.HOME.SURVEY_LIST)}}</h4>
        <p>{{_(KEYS.HOME.SURVEYS_HINT)}}</p>
        <span class="card-link">{{_(KEYS.HOME.OPEN)}} <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
      </a>
    </div>
  </section>

  <section class="home-section" *ngIf="canOpen('/module/device/create') || (downloadLinks?.allocatorApp?.windows && !isCustomTranslationScope) || (downloadLinks?.userGuide && downloadLinks?.userGuide[lang])">
    <h3 class="section-title">{{_(KEYS.HOME.SETUP_HELP)}}</h3>
    <div class="resource-grid">
      <article class="home-card device-card" *ngIf="canOpen('/module/device/create')">
        <div class="device-copy">
          <span class="card-icon"><i class="fa fa-tablet" aria-hidden="true"></i></span>
          <h4>{{_(KEYS.HOME.CONNECT_DEVICE)}}</h4>
          <p>{{_(KEYS.HOME.DEVICE_HINT)}}</p>
          <ol class="device-steps">
            <li>{{_(KEYS.HOME.INSTALL_APP)}}</li>
            <li>{{_(KEYS.HOME.CONNECT_WIFI)}}</li>
            <li>{{_(KEYS.HOME.SCAN_CODE)}}</li>
          </ol>
        </div>
        <div class="device-qr" role="img" [attr.aria-label]="_(KEYS.HOME.DEVICE_QR)">
          <app-init-device-qr-code></app-init-device-qr-code>
        </div>
      </article>
      <article class="home-card resource-card" *ngIf="downloadLinks?.allocatorApp?.windows && !isCustomTranslationScope">
        <span class="card-icon"><i class="fa fa-download" aria-hidden="true"></i></span>
        <h4>{{_(KEYS.HOME.ALLOCATOR_APP)}}</h4>
        <p>{{_(KEYS.HOME.ALLOCATOR_HINT)}}</p>
        <div class="card-actions download-actions">
          <a *ngIf="downloadLinks?.allocatorApp?.windows" [href]="downloadLinks.allocatorApp.windows">
            <i class="fa fa-windows" aria-hidden="true"></i> Windows
          </a>
          <a *ngIf="downloadLinks?.allocatorApp?.mac" [href]="downloadLinks.allocatorApp.mac">
            <i class="fa fa-apple" aria-hidden="true"></i> macOS
          </a>
          <a *ngIf="downloadLinks?.allocatorApp?.linux" [href]="downloadLinks.allocatorApp.linux">
            <i class="fa fa-linux" aria-hidden="true"></i> Linux
          </a>
        </div>
      </article>
      <article class="home-card resource-card" *ngIf="downloadLinks?.userGuide && downloadLinks?.userGuide[lang]">
        <span class="card-icon"><i class="fa fa-question-circle-o" aria-hidden="true"></i></span>
        <h4>{{_(KEYS.HOME.USER_GUIDE_TITLE)}}</h4>
        <p>{{_(KEYS.HOME.GUIDE_HINT)}}</p>
        <a class="card-link" [href]="downloadLinks.userGuide[lang]">
          {{_(KEYS.HOME.USER_GUIDE, {lang: lang})}} <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </a>
      </article>
    </div>
  </section>
</div>
